// Results (29 Oct 2026, docs/specs/NAVIGATION_2026_10.md): is it working? The overview is sales performance with the
// engine flow Sankey (Craig: the Sankey stays the overview's main chart), then outreach, sales and time saved. The
// overview and Outreach unlock after the first email (FirstSendGate); before that their figures are all zero.
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
import type { SteppedModule } from "./types";
import { screen } from "./screen";
const FirstSendGate = screen(() => import("../components/FirstSendGate"), "FirstSendGate");

const Performance = screen(() => import("../screens/Performance"), "Performance");
const ResultsPage = screen(() => import("../screens/find/Results"), "ResultsPage");
const AdvicePage = screen(() => import("../screens/find/Advice"), "AdvicePage");
const TimeSavedPage = screen(() => import("../screens/find/TimeSaved"), "TimeSavedPage");
const pages = () => import("../screens/pipeline/ConnectPages");
const PipelineSummary = screen(pages, "PipelineSummary");
const SpeedFiguresPage = screen(pages, "SpeedFiguresPage");
const ConnectTimePage = screen(() => import("../screens/pipeline/ConnectTime"), "ConnectTimePage");
const PaymentsPerformance = screen(() => import("../screens/pipeline/PaymentsAccount"), "PaymentsPerformance");

export const results: SteppedModule = {
  key: "results",
  label: "Results",
  layout: "steps",
  tabs: [
    { key: "overview", label: "Overview", pages: [{ slug: "", label: "Overview", step: "10.8", render: () => <FirstSendGate><Performance /></FirstSendGate> }] },
    {
      key: "outreach",
      label: "Outreach",
      pages: [
        { slug: "", label: "Outreach results", step: "10.8", render: () => <FirstSendGate><ResultsPage /></FirstSendGate> },
        { slug: "advice", label: "Advice", step: "10.9", render: () => <FirstSendGate><AdvicePage /></FirstSendGate> },
      ],
    },
    {
      key: "sales",
      label: "Sales",
      pages: [
        { slug: "", label: "Pipeline", step: "6.W", render: () => <PipelineSummary /> },
        { slug: "speed", label: "Speed to lead", step: "1.61", render: () => <SpeedFiguresPage /> },
        { slug: "payments", label: "Payments", step: "9.21", render: () => <PaymentsPerformance /> },
      ],
    },
    {
      key: "time",
      label: "Time saved",
      pages: [
        { slug: "", label: "Outreach", step: "10.8", render: () => <TimeSavedPage /> },
        { slug: "conversations", label: "Conversations", step: "10.8", render: () => <ConnectTimePage /> },
      ],
    },
  ],
  taskHomes: {
    // 10.20 replies dropping on a search is advice (walk-through item 61); Settings › Sending's health shows it too
    search_replies_dropped: ["/results/outreach/advice"],
  },
};
